import { useEffect, useState } from "react";

interface BackToTopProps {
  /** Scroll distance (px) after which the button appears. */
  showAfter?: number;
  /** Optional label shown next to the icon on wider screens. */
  label?: string;
  /** Extra classes for positioning overrides. */
  className?: string;
}

export default function BackToTop({ showAfter = 480, label = "Back to top", className = "" }: BackToTopProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > showAfter);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [showAfter]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      className={`fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-foreground-950 px-4 py-3 text-sm font-semibold text-background-50 transition-all duration-300 hover:bg-foreground-800 cursor-pointer md:bottom-8 md:right-8 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      } ${className}`}
    >
      <span className="flex h-4 w-4 items-center justify-center">
        <i className="ri-arrow-up-line text-base"></i>
      </span>
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
}